// extracted by mini-css-extract-plugin
module.exports = {"section":"RegionDetail_section__1gFc6","editor":"RegionDetail_editor__Rn6CJ","btn":"RegionDetail_btn__N_cn3"};